import 'emoji-mart/css/emoji-mart.css';

import { configure } from 'mobx';
import ReactDOM from 'react-dom';
import { createSDK, SDK } from 'sdk';

import App from './app';

export type SettingsType = {
	showcaseId: number;
	basePath: string;
	hideOpenButton?: boolean;
	token?: string;
	attributes?: { [key: string]: string };
	enableInvolve?: boolean;
	rootId?: string;
	shouldOpenOnIncoming?: boolean;
	mobileWidth?: number;
	mobileHeight?: number;
};

configure({
	useProxies: 'ifavailable',
	computedRequiresReaction: true,
	reactionRequiresObservable: true,
});

type WindowType = Window & typeof global & { initializeChat: (settings: SettingsType) => SDK; sdk: SDK };
// нет strict mode, т.к. вылазит warning от react-select
// см https://github.com/JedWatson/react-select/issues/4068
(window as WindowType).initializeChat = (settings: SettingsType): SDK => {
	let holder: HTMLElement | null = null;
	if (settings.rootId) {
		holder = document.getElementById(settings.rootId);
	}
	if (!holder) {
		holder = document.createElement('div');
		document.body.appendChild(holder);
	}
	const sdk = createSDK(
		settings.showcaseId,
		settings.basePath,
		settings.token,
		settings.attributes,
		settings.enableInvolve,
		settings.shouldOpenOnIncoming,
		settings.mobileWidth,
		settings.mobileHeight
	);

	ReactDOM.render(<App sdk={sdk} hideOpenButton={!!settings.hideOpenButton} />, holder);
	return sdk;
};

process.env.NODE_ENV === 'development' &&
	process.env.REACT_APP_SHOWCASE_ID_DEV &&
	process.env.REACT_APP_BASE_PATH_DEV &&
	((window as WindowType).sdk = (window as WindowType).initializeChat({
		showcaseId: +process.env.REACT_APP_SHOWCASE_ID_DEV,
		basePath: process.env.REACT_APP_BASE_PATH_DEV,
		enableInvolve: true,
		rootId: 'root',
	}));
